import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { PageDetail } from '@dal/core';

@Component({
  selector: 'dal-pagination-bar',
  templateUrl: './pagination-bar.component.html',
  styleUrl: './pagination-bar.component.scss',
})
export class PaginationBarComponent implements OnChanges {
  @Input() searchCount: number = 1;
  @Input() item: string = 'Asset';
  @Input() currentPage: number = 1;
  @Input() itemsPerPage: number = 50;  //default
  @Output() PageChangeEvent: EventEmitter<PageDetail> = new EventEmitter();
  @Input() totalPages: number=1;
  
  ngOnChanges() {
    this.totalPages = Math.ceil(this.searchCount / this.itemsPerPage) || 1;
  }

  onPageChange(direction: number, direct = false): void {
    if (direction === -1 && this.currentPage > 1 && this.currentPage <= this.totalPages) {
      this.changePage(this.currentPage - 1);
    } else if (direction === 1 && this.currentPage < this.totalPages) {
      this.changePage(this.currentPage + 1);
    }
    // for input box change, direction is considered as pageNum
    if (direct && direction > 0 && direction <= this.totalPages) {
      this.changePage(direction)
    }
  }

  changePage(page: number):void {
    this.currentPage = page;
    const pageDetails: PageDetail = { itemsPerPage: this.itemsPerPage, currentPage: this.currentPage };
    this.PageChangeEvent.emit(pageDetails);
  }
}
